<div class="tab-pane" role="tabpanel" id="calculista">
    <fieldset id="agregar_calculista" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Informaci&oacute;n del calculista</strong></h3>
            <hr>
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <p>Ingrese el RUT para agregar calculistas</p>
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label for="rut_arq" class="col-md-1" style="padding-top: 15px">RUT</label>
                            <div class="col-md-2">
                                <form [formGroup]="rut_arq">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Rut" id="rut_arq" name="rut_arq" formControlName="rut" formatRut [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="rut_arq.controls?.rut.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                        <mat-error *ngIf="rut_arq.controls?.rut.hasError('invalidRut')">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </form>
                            </div>
                            <div class="col-md-2">
                                <button mat-raised-button color="primary" style="padding-top: 5px" id="b_rut_arq" [disabled]="!rut_arq.valid" (click)="get_calculista(rut_arq.controls.rut.value)">
                                            Agregar calculista
                                        <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                    </button>
                            </div>
                        </div>
                    </div>
                    <!--Detalle de los calculistas-->
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>RUT</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.rut | rut}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>NOMBRE</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <span>{{row.nombre}}</span><span> {{row.apellido_pat}}</span><span> {{row.apellido_mat}}</span>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="update_calculista(row.rut,rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-eye-open"></i></span>
                                    <span (click)="delete_calculista(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                    </div>
                </div>

            </div>
        </div>
    </fieldset>
    <!-- Modal -->

    <!--Material Modal Dialog-->
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n del calculista</h2>
        <mat-dialog-content>

            <div class="form-horizontal">
                <div class="alert alert-info" role="alert">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <strong> Debe ingresar la informacion del calculista arquitecte</strong>, su solicitud pasar&aacute; por un proceso de verificaci&oacute;n del arquitecte ingresado. <br>
                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                    <strong> Campos obligatorios marcados con un (<span style="color: red">*</span>)</strong>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="rut">RUT(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="rut" name="rut" type="text" placeholder="RUT" class="form-control input-md" [(ngModel)]="calculista.rut" readonly>
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="nombre">Nombre o Raz&oacute;n Social(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="nombre" name="nombre" type="text" placeholder="Nombre o Raz&oacute;n Social" class="form-control input-md" [(ngModel)]="calculista.nombre">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div id="hide-pat-enterprise">
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="apellido_pat">Apellido Paterno(<span style="color: red">*</span>)</label>
                        <div class="col-md-6">
                            <input id="apellido_pat" name="apellido_pat" type="text" placeholder="Apellido Paterno" class="form-control input-md" [(ngModel)]="calculista.apellido_pat">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="apellido_mat">Apellido Materno</label>
                        <div class="col-md-6">
                            <input id="apellido_mat" name="apellido_mat" type="text" placeholder="Apellido Materno" class="form-control input-md" [(ngModel)]="calculista.apellido_mat">
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
                <div hidden="hidden">
                    <div class="form-group">
                        <div class="col-md-1"></div>
                        <label class="col-md-2 control-label" for="direccion">Direcci&oacute;n: Calle(<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="direccion" name="direccion" type="text" placeholder="Calle" class="form-control input-md" [(ngModel)]="calculista.direccion">
                        </div>
                        <label class="col-md-2 control-label" for="dir_num_arquitect">Direcci&oacute;n: Numero(<span style="color: red">*</span>)</label>
                        <div class="col-md-3">
                            <input id="dir_num_arquitect" name="direccion_num" type="text" placeholder="Numero" class="form-control input-md" [(ngModel)]="calculista.direccion_num">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-4 control-label" for="comuna">Comuna(<span style="color: red">*</span>)</label>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width">
                                <input type="text" id="Com_nombre" name="Com_nombre" aria-label="Nombre" matInput [formControl]="nombreComuna" [matAutocomplete]="auto" [(ngModel)]="calculista.comuna">
                                <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                    {{option}}
                                </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <!-- <input id="comuna" name="comuna" type="text" placeholder="Comuna" [(ngModel)]="propietario.comuna" class="form-control input-md"> -->
                        </div>
                        <div class="col-md-2"></div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fono">Tel&eacute;fono</label>
                    <div class="col-md-6">
                        <input id="fono" name="fono" type="text" placeholder="Tel&eacute;fono" class="form-control input-md" [(ngModel)]="calculista.fono">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="fax">Fax</label>
                    <div class="col-md-6">
                        <input id="fax" name="fax" type="text" placeholder="fax" class="form-control input-md" [(ngModel)]="calculista.fax">
                    </div>
                    <div class="col-md-2"></div>
                </div>
                <div class="form-group">
                    <label class="col-md-4 control-label" for="mail">Email(<span style="color: red">*</span>)</label>
                    <div class="col-md-6">
                        <input id="mail" name="mail" type="email" placeholder="mail@ejemplo.com" class="form-control input-md" [(ngModel)]="calculista.mail">
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>

        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_calculista" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_arquitect" (click)="savecalculista()" [disabled]="!calculista.rut || !calculista.mail || !calculista.nombre || !calculista.apellido_pat">Ingresar calculista <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
    <!--End Material Dialog-->
</div>

<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
       No ingreso ningun dato del Calculista.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>


<div class="separator"></div>